import db from './../db';

export default {
    put: function(url, data) {
        return new Promise(function(resolve, reject) {
            const errors = [];
            //TextValue is required
            if (data.textValue === null || data.textValue === '') {
                errors.push(
                    {
                        property: 'TextValue',
                        message: 'MESSAGE__FORM__TEXT_REQUIRED'
                    }
                );
            }
            //TextareaValue is required
            if (data.textareaValue === null || data.textareaValue === '') {
                errors.push(
                    {
                        property: 'TextareaValue',
                        message: 'MESSAGE__FORM__TEXTAREA_REQUIRED'
                    }
                );
            }
            //CheckboxValue is required
            if (!data.checkboxValue) {
                errors.push(
                    {
                        property: 'CheckboxValue',
                        message: 'MESSAGE__FORM__CHECKBOX_REQUIRED'
                    }
                );
            }
            //DropdownValue is required
            if (data.dropdownValue === null || data.dropdownValue === '') {
                errors.push(
                    {
                        property: 'DropdownValue',
                        message: 'MESSAGE__FORM__DROPDOWN_REQUIRED'
                    }
                );
            }
            //RadioValue is required
            if (data.radioValue === null || data.radioValue === '') {
                errors.push(
                    {
                        property: 'RadioValue',
                        message: 'MESSAGE__FORM__RADIO_REQUIRED'
                    }
                );
            }
            //Date is required
            if (data.date === null) {
                errors.push(
                    {
                        property: 'Date',
                        message: 'MESSAGE__FORM__DATE_REQUIRED'
                    }
                );
            }
            //DateTime is required
            if (data.dateTime === null) {
                errors.push(
                    {
                        property: 'DateTime',
                        message: 'MESSAGE__FORM__DATETIME_REQUIRED'
                    }
                );
            }


            //Invalid credentials
            if (errors.length > 0) {
                reject({
                    status: 400,
                    body: errors
                });
                return;
            }

            db.textValue = data.textValue;
            db.textareaValue = data.textareaValue;
            db.checkboxValue = data.checkboxValue;
            db.dropdownValue = data.dropdownValue;
            db.radioValue = data.radioValue;
            db.segmentedValue = data.segmentedValue;
            db.date = data.date;
            db.dateTime = data.dateTime;
            db.save();

            //Ok
            resolve({
                body: {}
            });
        });
    }
};



// WEBPACK FOOTER //
// ./test/data/form/save.js